import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CardLinkOffer, CardLinkOfferOptions, CardLinkOffersQuery, CardLinkOffersService, MemberQuery } from '@fgb/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fgbcl-card-link-offers-list',
  templateUrl: './card-link-offers-list.component.html',
  styleUrls: ['./card-link-offers-list.component.scss'],
})
export class CardLinkOffersListComponent implements OnInit, OnChanges, OnDestroy {
  lcid: string;
  offers$: Observable<CardLinkOffer[]> | undefined;
  offerCount$: Observable<number | undefined>;
  @Input() cardLinkOfferOptions: CardLinkOfferOptions;
  @Input() labelName: string = '';
  @Input() horizontalLine: boolean = true;
  private _destroyed$ = new Subject<void>();

  showMoreButton: boolean = false;
  offerCount: number;

  constructor(
    private cardLinkOffersQuery: CardLinkOffersQuery,
    private cardLinkOffersService: CardLinkOffersService,
    private memberQuery: MemberQuery
  ) {}

  ngOnInit(): void {
    this.lcid = this.memberQuery.getUserContext().lcid;
    this.cardLinkOffersService.fatchAffiliateOffer().toPromise();
    this.fetchOffers();
  }

  /**
   * Detect the input changes
   * and fatch the offers
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.cardLinkOfferOptions.firstChange) {
      this.fetchOffers();
    }
  }

  /**
   *@return the offers according to the types
   *it take the values from cardLinkOfferOptions model and do accordting
   *to the configurations
   */

  fetchOffers() {
    switch (this.cardLinkOfferOptions.offerType) {
      case 1:
        this.offers$ = this.cardLinkOffersQuery.selectAllOffer(this.cardLinkOfferOptions.limit);
        this.offerCount$ = this.cardLinkOffersQuery.selectCount();
        break;
      case 2:
        this.offers$ = this.cardLinkOffersQuery.featuredOffers(this.cardLinkOfferOptions.limit);
        this.offerCount$ = this.cardLinkOffersQuery.featuredOffersCount();
        break;
      case 3:
        this.offers$ = this.cardLinkOffersQuery.selectRecommendedOffers(
          this.cardLinkOfferOptions.excludingOfferId,
          this.cardLinkOfferOptions.limit
        );
        this.offerCount$ = this.cardLinkOffersQuery.recommendOffersCount(this.cardLinkOfferOptions.excludingOfferId);
        break;
      case 4:
        this.offers$ = this.cardLinkOffersQuery.selectOtherOffer(
          this.cardLinkOfferOptions.companyID,
          this.cardLinkOfferOptions.excludingOfferId,
          this.cardLinkOfferOptions.limit
        );
        this.offerCount$ = this.cardLinkOffersQuery.selectOtherOfferCount(
          this.cardLinkOfferOptions.companyID,
          this.cardLinkOfferOptions.excludingOfferId
        );
        break;
      case 5:
        this.offers$ = this.cardLinkOffersQuery.selectActivatedOffer(this.cardLinkOfferOptions.limit);
        this.offerCount$ = this.cardLinkOffersQuery.selectActivatedOffersCount();
        break;
      case 6:
        this.cardLinkOfferOptions.showMoreButton = false;
        this.cardLinkOfferOptions.limit = 0;
        this.offers$ = this.cardLinkOfferOptions.customOffersData;

        break;
      default:
        this.offers$ = this.cardLinkOffersQuery.selectAll();
        this.offerCount$ = this.cardLinkOffersQuery.selectCount();
        break;
    }

    this.getCount(this.offerCount$);
  }

  getCount(count: Observable<number | undefined>) {
    count.pipe(takeUntil(this._destroyed$)).subscribe((res) => {
      this.offerCount = res ?? 0;
      this.checkCardLinkOptions();
    });
  }

  checkCardLinkOptions() {
    if (
      this.cardLinkOfferOptions.showMoreIncrement &&
      this.cardLinkOfferOptions.showMoreButton &&
      this.cardLinkOfferOptions?.limit
    ) {
      if (this.offerCount > this.cardLinkOfferOptions.limit && this.cardLinkOfferOptions.limit != 0) {
        this.showMoreButton = true;
      } else {
        this.showMoreButton = false;
      }
    } else {
      this.showMoreButton = false;
    }
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
